const trimVariables = (obj) => {
    const newVariables = {};
    Object.entries(obj).forEach(v => {
        // console.log(v, typeof(v[1]), v[1], v[1].trim());
        newVariables[v[0]] = typeof v[1] === "string" ? v[1].trim(): v[1];
    });
    return newVariables;
};

module.exports={trimVariables}